import { render, staticRenderFns } from "./bulkCreate.vue?vue&type=template&id=8ea46bda&scoped=true&"
import script from "./bulkCreate.vue?vue&type=script&lang=js&"
export * from "./bulkCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea46bda",
  null
  
)

export default component.exports